import { errorHandler } from '@/services/error-handler'

export function registerGlobalErrors() {
  // Runtime JS errors + resource loading errors
  window.addEventListener(
    'error',
    (event) => {
      const target = event.target

      // image/js/css/file not loaded
      if (target && target !== window) {
        const url = target.src || target.href

        if (url) {
          errorHandler.send(new Error('Resource failed to load'), {
            type: 'resource-load-error',
            tagName: target.tagName,
            resourceUrl: url,
          })

          return
        }
      }

      errorHandler.send(event.error || new Error(event.message), {
        type: 'window-error',
        filename: event.filename,
        line: event.lineno,
        column: event.colno,
      })
    },
    true,
  )

  // Async promise errors
  window.addEventListener('unhandledrejection', (event) => {
    errorHandler.send(event.reason || new Error('Unhandled Promise Rejection'), {
      type: 'promise-rejection',
    })
  })

  // Optional: Offline detection
  window.addEventListener('offline', () => {
    errorHandler.send(new Error('Internet connection lost'), {
      type: 'network-offline',
    })
  })
}